import './lib/uuid';
import { Factory } from 'rosie';

Factory.define('SnippetSearchResult')
  .extend('Uuid')
  .attr('query', ['query'], query => {
    return Factory.attributes('SearchQuery', query);
  })
  .attr('requestedAt');



// WEBPACK FOOTER //
// ./factories/snippet_search_result_factory.js